import React from 'react'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/shadcn/tooltip'
import { cn } from '@/lib/utils'

interface TooltipButtonProps {
  children: React.ReactNode
  tooltip: string
  className?: string
  contentClassName?: string
}

/**
 * TooltipButton - A reusable component that wraps any element with a tooltip
 *
 * @param children - The element to wrap with a tooltip (usually a button)
 * @param tooltip - The tooltip text to display
 * @param className - Optional className for the wrapper
 * @param contentClassName - Optional className for the tooltip content
 */
export function TooltipButton({
  children,
  tooltip,
  className,
  contentClassName = 'bg-foreground text-xs text-background',
}: TooltipButtonProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild className={cn(className)}>
          {children}
        </TooltipTrigger>
        <TooltipContent className={cn(contentClassName)}>{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
